import React from 'react';

import { cn } from '../../lib/utils';

// Shared pill button for the auth flows. `primary` is the solid black action;
// `secondary` is the bordered gray alternate auth choice.
const VARIANT_CLASSES = {
  primary: 'bg-black text-white hover:bg-[#1a1a1a] active:bg-[#333]',
  secondary: 'border border-[#E5E7ED] bg-[#F3F4F6] text-gray-500 hover:bg-[#eceef1]',
};

export default function AuthButton({ children, className, disabled, href, onClick, rel, target, type = 'submit', variant = 'primary' }) {
  const classes = cn(
    'flex h-12 w-full cursor-pointer items-center justify-center gap-2 rounded-full px-6 text-center text-[14px] leading-[18px] font-medium transition-all active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60 disabled:active:scale-100',
    VARIANT_CLASSES[variant],
    className,
  );

  if (href) {
    return (
      <a className={classes} data-app-region="none" href={href} onClick={onClick} rel={rel} target={target}>
        {children}
      </a>
    );
  }

  return (
    <button
      className={classes}
      data-app-region="none"
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  );
}
